export default __webpack_public_path__ + "static/media/aboutslider1.42ddc654.webp";